<template>
  <div class="login" id="login" :style="{height: screenHeight+'px'}">
    <div class="box">
      <div class="title" style="text-align: center; margin-top: 10px;">
<!--        <img src="../assets/logo1.png" style="width: 300px;"/>-->
        <h1 class="head-title">工业物联网管理系统</h1>
      </div>

      <el-form key="man" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm pr80" hide-required-asterisk>
        <el-form-item label="账号" prop="username">
          <el-input type="text" v-model="ruleForm.username" autocomplete="off" @keyup.enter.native="submitForm('ruleForm')" maxlength="32" @change="onUsernameChange"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="userpwd">
          <el-input type="password" v-model="ruleForm.userpwd" autocomplete="off" @keyup.enter.native="submitForm('ruleForm')" maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="verifyCode">
          <el-row>
            <el-col :span="12">
              <el-input v-model="ruleForm.verifyCode" @keyup.enter.native="submitForm('ruleForm')" maxlength="4"></el-input>
            </el-col>
            <el-col :span="6" :offset="3" style="height: 40px">
              <img v-if="!imgLoading" :src="imgUrl" alt="" @click="this.getVerifyCode" style="height: 100%">
              <div v-else style="color: #f2f2f2;">
                正在加载
              </div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="谷歌验证码" prop="googleVerifyCode" v-if="googleVerifyShow">
          <el-row>
            <el-input type="text" v-model="ruleForm.googleVerifyCode" autocomplete="off" @keyup.enter.native="submitForm('ruleForm')" maxlength="6"></el-input>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button style="width: 100%" type="primary" :loading="loginLoading" @click="submitForm('ruleForm')">登录</el-button>
        </el-form-item>
      </el-form>

    </div>
    <div class="copyright" v-if="screenHeight > 420">Copyright © 2024 All rights reserved 版权所有 广州赛程电子科技有限公司 <a href="http://beian.miit.gov.cn" target="_blank" style="text-decoration: none;color: rgba(255,255,255,.6)">粤ICP备2024332972号</a></div>
    <div class="canvaszz" :style="{height: screenHeight+'px'}"></div>
    <canvas id="canvas" :style="{height: screenHeight+'px'}"></canvas>
  </div>
</template>

<script>
import axios from 'axios'
import utils from '@/utils/utils'
import { resetRouter } from '@/router'
import rsa from '@/utils/rsa'
export default {
  data () {
    return {
      loginLoading: false,
      imgLoading: true,
      imgUrl: '',
      googleVerifyShow: false,
      ruleForm: {
        userpwd: '',
        username: '',
        verifyCode: '',
        googleVerifyCode: ''
      },
      rules: {
        verifyCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        userpwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        googleVerifyCode: [{ required: true, message: '请输入谷歌验证码', trigger: 'blur' }]
      },
      screenHeight: window.innerHeight // 屏幕高度
    }
  },
  watch: {
    'screenHeight': function (val) { // 监听屏幕高度变化
      var oIframe = document.getElementById('login')
      if (val < 500) {
        return
      }
      if (oIframe) {
        oIframe.style.height = Number(val) + 'px' // '120'是页面布局调整，可去除
      }
    }
  },
  mounted () {
    // this.getGoogleFlag()
    this.getVerifyCode()
    this.initCanvas()
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login()
        } else {
          return false
        }
      })
    },
    // 获取验证码
    getVerifyCode () {
      this.imgLoading = true
      axios({
        url: this.baseUrl + '/verifyCode',
        method: 'get',
        responseType: 'arraybuffer'
      }).then(response => {
        // 转换为base64格式
        return 'data:image/png;base64,' + btoa(
          new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
        )
      }).then((data) => {
        this.imgLoading = false

        this.imgUrl = data
      }).catch(err => {
        console.log(err)
      })
    },
    onUsernameChange () {
      if (this.ruleForm.username && this.ruleForm.username.indexOf('/') == -1) {
        this.getGoogleFlag(this.ruleForm.username)
      }
    },
    getGoogleFlag (username) {
      axios({
        url: this.baseUrl + '/googleFlag/' + username,
        method: 'get'
      }).then(res => {
        if (res.data.code === '0000') {
          this.googleVerifyShow = res.data.data
        }
      }).catch(err => {
        console.log(err, 'loginerr')
      })
    },
    login () {
      let data, url
      data = {
        username: this.ruleForm.username,
        userpwd: rsa.rsaPublicData(this.ruleForm.userpwd),
        verifyCode: this.ruleForm.verifyCode,
        googleVerifyCode: this.ruleForm.googleVerifyCode
      }
      url = this.baseUrl + '/login'

      // console.log(data)

      this.loginLoading = true
      axios({
        method: 'post',
        url,
        data
      }).then((res) => {
        // console.log(res)
        if (res.data.code === '0000') {
          sessionStorage.setItem('token', res.data.data.userToken)
          // console.log(res.data.data.userToken)
          // sessionStorage.setItem('token', res.data.code)
          sessionStorage.setItem('userInfo', JSON.stringify(res.data.data))

          this.getMenuData()
        } else if (res.data.message.indexOf('密码错误') > -1 || res.data.message.indexOf('验证码错误') > -1 || res.data.message.indexOf('验证码已失效') > -1) {
          this.getVerifyCode() // 只要密码错误就重新刷新验证码
        }
        this.loginLoading = false
      }).catch(err => {
        console.log(err, 'loginerr')
        this.loginLoading = false
      })
    },
    getMenuData () {
      axios({
        url: this.baseUrl + '/menu',
        method: 'get'
      }).then((res) => {
        sessionStorage.setItem('menuData', JSON.stringify(res.data.data))
        const MENU_DATA = JSON.parse(sessionStorage.getItem('menuData'))
        sessionStorage.setItem('isLoad', 'isLoad')
        let asyncRouteData = res.data.data || []
        asyncRouteData = utils.findTree(asyncRouteData, 3)
        let routeData = JSON.parse(JSON.stringify(this.$router.options.routes))

        let routesData = [
          {
            path: '/home',
            name: 'home',
            component: () => import('@/components/header.vue'),
            children: []
          }
        ]

        asyncRouteData.forEach(item => {
          routesData[0].children.push({
            path: `/${item.menuId}`,
            name: item.menuId,
            component: () => import(`@/views${item.pageUrl}.vue`)
          })
        })

        routeData.push(routesData)

        resetRouter()
        // this.$router.addRoutes(routesData)
        routesData.forEach(item => this.$router.addRoute(item))
        const subMenu = MENU_DATA.filter((item, index) => {
          if (item.menuId === MENU_DATA[0].menuId) {
            return true
          }
        })
        sessionStorage.setItem('subMenu', JSON.stringify(subMenu))
        // this.$router.push({ name: MENU_DATA[0].menuId })
        this.$router.push({ name: 'home' })

        this.loginLoading = false
      }).catch(err => {
        console.log(err, 'getMenuData')
        this.loginLoading = false
      })
    },
    // 初始化canvas
    initCanvas () {
      var _this = this
      window.onresize = function () { // 定义窗口大小变更通知事件
        _this.screenHeight = document.documentElement.clientHeight // 窗口高度
      }
      var canvas = document.getElementById('canvas')
      var ctx = canvas.getContext('2d')
      var w = canvas.width = window.innerWidth
      var h = canvas.height = window.innerHeight
      var hue = 217
      var stars = []
      var count = 0
      var maxStars = 1300 // 星星数量

      var canvas2 = document.createElement('canvas')
      var ctx2 = canvas2.getContext('2d')
      canvas2.width = 100
      canvas2.height = 100
      var half = canvas2.width / 2
      var gradient2 = ctx2.createRadialGradient(half, half, 0, half, half, half)
      gradient2.addColorStop(0.025, '#CCC')
      gradient2.addColorStop(0.1, 'hsl(' + hue + ', 61%, 33%)')
      gradient2.addColorStop(0.25, 'hsl(' + hue + ', 64%, 6%)')
      gradient2.addColorStop(1, 'transparent')

      ctx2.fillStyle = gradient2
      ctx2.beginPath()
      ctx2.arc(half, half, half, 0, Math.PI * 2)
      ctx2.fill()

      // End cache

      function random (min, max) {
        if (arguments.length < 2) {
          max = min
          min = 0
        }

        if (min > max) {
          var hold = max
          max = min
          min = hold
        }

        return Math.floor(Math.random() * (max - min + 1)) + min
      }

      function maxOrbit (x, y) {
        var max = Math.max(x, y)
        var diameter = Math.round(Math.sqrt(max * max + max * max))
        return diameter / 2
        // 星星移动范围，值越大范围越小，
      }

      var Star = function () {
        this.orbitRadius = random(maxOrbit(w, h))
        this.radius = random(60, this.orbitRadius) / 8
        // 星星大小
        this.orbitX = w / 2
        this.orbitY = h / 2
        this.timePassed = random(0, maxStars)
        this.speed = random(this.orbitRadius) / 50000
        // 星星移动速度
        this.alpha = random(2, 10) / 10

        count++
        stars[count] = this
      }

      Star.prototype.draw = function () {
        var x = Math.sin(this.timePassed) * this.orbitRadius + this.orbitX
        var y = Math.cos(this.timePassed) * this.orbitRadius + this.orbitY
        var twinkle = random(10)

        if (twinkle === 1 && this.alpha > 0) {
          this.alpha -= 0.05
        } else if (twinkle === 2 && this.alpha < 1) {
          this.alpha += 0.05
        }

        ctx.globalAlpha = this.alpha
        ctx.drawImage(canvas2, x - this.radius / 2, y - this.radius / 2, this.radius, this.radius)
        this.timePassed += this.speed
      }

      for (var i = 0; i < maxStars; i++) {
        /* eslint-disable no-new */
        new Star()
      }

      function animation () {
        ctx.globalCompositeOperation = 'source-over'
        ctx.globalAlpha = 0.5 // 尾巴
        ctx.fillStyle = 'hsla(' + hue + ', 64%, 6%, 2)'
        ctx.fillRect(0, 0, w, h)

        ctx.globalCompositeOperation = 'lighter'
        for (var i = 1, l = stars.length; i < l; i++) {
          stars[i].draw()
        };

        window.requestAnimationFrame(animation)
      }

      animation()
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  overflow: hidden;
  position: relative;
  min-height: 500px;
  background-color: #2d3a4b;
  .el-button.is-disabled {
    color: #333;
  }
  .check-code .el-input input {
    padding-right: 100px;
  }
  .check-code .el-button.is-disabled {
    color: #ccc;
  }
}
.title {
  margin-bottom: 16px;
}
.head-title {
    text-align: center;
    font-size: 2em;
    margin: 0 auto;
    padding: 30px 0 10px 0;
    color: #333;
}
.box {
    // background-color: rgba(45, 58, 75, .6);
    position: absolute;
    transform: translate(-50%,-60%);
    z-index: 1000;
    background: rgba(255,255,255,.8);
    border-radius: 4px;
    left: 50%;
    top: 50%;
    width: 480px;
    min-height: 300px;
}
.pr80 {
    padding-right: 80px !important;
    padding-bottom: 10px;
}
canvas {
  /* min-height: 500px; */
  width: 100%;
  height: auto /*默认全屏显示 可自己设置高度640px*/;
  display: inline-block;
  vertical-align: baseline;
  position: absolute;
  z-index: -1;
}
.canvaszz {
  width: 100%;
  background: url(./../assets/bg3.jpeg) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 10;
  filter: alpha(opacity=40);
  -moz-opacity: 0.4;
  -khtml-opacity: 0.4;
  opacity: 0.4;
}
.copyright {
  color: rgba(255, 255, 255, .6);
  position: fixed;
  text-align: center;
  margin-left: 50%;
  bottom: 20px;
  left: 0;
  right: 0;
  font-size: 12px;
  margin: 0 auto;
  z-index: 20;
}
</style>
